import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {SwatchComponent} from '../../../swatch/swatch.component';
import {ColorOption} from '../../../../../shared/models/appearance';

@Component({
  selector: 'motn-sort-table-cell-swatch',
  template: `
    <motn-swatch [color]="color" [size]="size" margin="0"></motn-swatch>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SwatchComponent,
  ],
})
export class SortTableCellSwatchComponent extends BaseCellComponent implements OnInit {
  @Input() color: ColorOption = '';
  @Input() size: number = 28;

  constructor() {
    super();
  }

  protected onInit(): void {
  }
}